import { Button, Container, Logo } from '@/design-system';
import { ThemeToggle } from '@/app/ThemeToggle';
import { useApplicantSession } from '@/lib/applicant/useApplicantSession';
import { useAuth } from '@/lib/auth/useAuth';
import styles from './LandingPage.module.css';

/**
 * The public page, for applicants first (decision 13): what this is, and the way
 * in. Staff have theirs beside it. How far the build has got is on the staff
 * Build page.
 */
export function LandingPage() {
  const { me } = useAuth();
  const { applicant } = useApplicantSession();

  return (
    <div className={styles.page}>
      <header className={styles.header}>
        <Container>
          <div className={styles.headerInner}>
            <Logo height={28} />
            <ThemeToggle />
          </div>
        </Container>
      </header>

      <main className={styles.main}>
        <Container>
          <div className={styles.hero}>
            <p className={styles.eyebrow}>Sierra Bravo</p>
            <h1 className={styles.title}>Remittance Licensing Intake</h1>
            <p className={styles.lead}>
              For remittance businesses seeking a licence from the Central Bank of Kenya,
              the Bank of Uganda or the Bank of Tanzania. Tell us about the business and the
              people behind it, attach what you have, and our advisory team will take it from
              there.
            </p>
            <div className={styles.actions}>
              <Button href="/apply" variant="primary" size="lg">
                {applicant ? 'Continue your application' : 'Apply'}
              </Button>
              {me ? (
                <Button href="/home" variant="secondary" size="lg">
                  Continue as {me.displayName}
                </Button>
              ) : (
                <Button href="/signin" variant="secondary" size="lg">
                  Staff sign in
                </Button>
              )}
            </div>
          </div>
        </Container>
      </main>
    </div>
  );
}
